// extracted by mini-css-extract-plugin
export default {"tooltip-container":"ToolTip_tooltip-container__sUAiQ","cont":"ToolTip_cont__AlXfC","toolTip":"ToolTip_toolTip__teNBW","infoCustGoals":"ToolTip_infoCustGoals__wXhDk"};